"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLE = void 0;
const TITLE = exports.TITLE = 'title';
